import { render, staticRenderFns } from "./ForecastModal_B2_LoadSales.vue?vue&type=template&id=01c6e714"
import script from "./ForecastModal_B2_LoadSales.vue?vue&type=script&lang=ts"
export * from "./ForecastModal_B2_LoadSales.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports